export default {
  methods: {
    chainStreamsBidirectional(eventName, streams) {
      if (streams.length < 2) {
        console.error('chainStreamsBidirectional. ' +
          'streams.length must be 2 or greater.')
        return
      }
      // ->
      let arr = streams.slice()
      let first = arr.shift()
      first.chain(eventName, arr)
      // <-
      arr = streams.slice().reverse()
      first = arr.shift()
      first.chain(eventName, arr)
    },
  }
}
